import insuranceLogoMapper, {
    insuranceCompanyLogoChecker
} from 'utils/insurance-logo-mapper/insurance-logo-mapper';

import Image from 'core/image';
import PriceTagItem from 'components/landing/tables/components/price-tag/price-tag-item';
import PropTypes from 'prop-types';
import RateOptionHeader from 'components/landing/top-rated-insurance/rate-option-header';
import styles from 'styles/LandingComponents.module.scss';
import { useTranslations } from 'next-intl';

const CheapCarVerticalItem = ({
    avgPrice,
    companyCode,
    culture,
    maxPrice,
    minPrice
}) => {
    const t = useTranslations('table.cheap-car-insurance.headers');
    const gap = 10;
    const WIDTH_MEDIUM = 90;
    const WIDTH_LARGE = 200;
    const LOGO_HEIGHT = 60;
    const companyNameDisplay = companyCode.toLowerCase();
    const isLogoAvailable = insuranceCompanyLogoChecker(
        companyCode,
        culture,
        'colored'
    );
    const logo = insuranceLogoMapper(companyCode, culture, 'colored');

    return (
        <div className={styles.landing__range_table_item}>
            <div className={styles.range_table__child_logo}>
                <RateOptionHeader
                    icon="shield"
                    label={t('car-insurance-company')}
                    gap={gap}
                />
                <>
                    <Image
                        src={logo}
                        alt={`${companyCode} Logo`}
                        width={isLogoAvailable ? WIDTH_LARGE : 150}
                        height={isLogoAvailable ? LOGO_HEIGHT : 45}
                    />
                    {!isLogoAvailable && (
                        <p className={styles.company_name_item}>
                            {companyNameDisplay}
                        </p>
                    )}
                </>
            </div>
            <div style={{ gap }} className={styles.range_table__child}>
                <RateOptionHeader
                    gap={gap}
                    icon="cheapest-price"
                    label={t('cheapest')}
                    width={WIDTH_MEDIUM}
                />
                {minPrice && <PriceTagItem value={minPrice} fontSize={17.5} />}
            </div>
            <div style={{ gap }} className={styles.range_table__child}>
                <RateOptionHeader
                    gap={gap}
                    icon="avg-price"
                    label={t('average')}
                    width={WIDTH_MEDIUM}
                />
                {avgPrice && <PriceTagItem value={avgPrice} fontSize={17.5} />}
            </div>
            <div style={{ gap }} className={styles.range_table__child}>
                <RateOptionHeader
                    gap={gap}
                    icon="maximum-price"
                    label={t('maximum')}
                    width={WIDTH_MEDIUM}
                />
                {maxPrice && <PriceTagItem value={maxPrice} fontSize={17.5} />}
            </div>
        </div>
    );
};

CheapCarVerticalItem.propTypes = {
    avgPrice: PropTypes.number,
    companyCode: PropTypes.string,
    culture: PropTypes.string,
    maxPrice: PropTypes.number,
    minPrice: PropTypes.number
};

export default CheapCarVerticalItem;
